import { Dialog, Button, Grid, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Content, ContentText, RadioGroupContainer } from "./styles";
import DialogActions from "../../../../DialogActions/DialogActions";
import DialogTitle from "../../../../DialogTitle/DialogTitle";
import LoadingOverlay from "../../../../LoadingOverlay/LoadingOverlay";

export enum ApproversOptions {
  exportSelectedDataWithActuallApprovers = "exportSelectedDataWithActuallApprovers",
  exportSelectedDataWithAllApprovers = "exportSelectedDataWithAllApprovers",
  exportAllDataWithActuallApprovers = "exportAllDataWithActuallApprovers",
  exportAllDataWithAllApprovers = "exportAllDataWithAllApprovers",
}

export const approversOptions: { [key: string]: { option: ApproversOptions; value: string; translationKey: string } } =
  {
    exportSelectedDataWithActuallApprovers: {
      option: ApproversOptions.exportSelectedDataWithActuallApprovers,
      value: "Export as excel selected data with actuall approvers",
      translationKey: "export_selected_with_actual",
    },
    exportSelectedDataWithAllApprovers: {
      option: ApproversOptions.exportSelectedDataWithAllApprovers,
      value: "Export as excel selected data with all approvers",
      translationKey: "export_selected_with_all",
    },
    exportAllDataWithActuallApprovers: {
      option: ApproversOptions.exportAllDataWithActuallApprovers,
      value: "Export as excel all data with actuall approvers",
      translationKey: "export_all_with_actual",
    },
    exportAllDataWithAllApprovers: {
      option: ApproversOptions.exportAllDataWithAllApprovers,
      value: "Export as all selected data with all approvers",
      translationKey: "export_all_with_all",
    },
  };

interface Props {
  handleExportToExcel: (option: ApproversOptions) => Promise<void>;
  disabled: boolean;
}

const ExportToExcelApproversDialog = ({ handleExportToExcel, disabled }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.employee_approvers";
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    approversOptions["exportSelectedDataWithActuallApprovers"].value
  );

  const handleExport = async () => {
    setLoading(true);
    try {
      const currOption = Object.keys(approversOptions).find((item) => approversOptions[item].value === selectedOption);

      if (currOption) {
        await handleExportToExcel(approversOptions[currOption].option);

        setLoading(false);

        setOpen(false);

        setSelectedOption(approversOptions["exportSelectedDataWithActuallApprovers"].value);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);

    setSelectedOption(approversOptions["exportSelectedDataWithActuallApprovers"].value);
  };

  return (
    <>
      <Button
        title={`${t("buttons.export")}`}
        variant="contained"
        onClick={() => setOpen(true)}
        sx={{ textWrap: "nowrap" }}
        disabled={disabled}
      >
        {`${t(`buttons.export`)}`}
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <LoadingOverlay loading={loading}>
          <DialogTitle
            title={`${t(`${tRP}.export_as_excel`)}`}
            handleClose={handleClose}
          />
          <Content>
            <Container>
              <Grid sx={{ padding: "5px" }}>
                <ContentText>{`${t(`${tRP}.select_how_to_export`)}`}:</ContentText>
              </Grid>

              <RadioGroupContainer>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="radio-group"
                    defaultValue={approversOptions["exportSelectedDataWithActuallApprovers"].value}
                    name="radio-buttons-group"
                    onChange={(event, value) => {
                      setSelectedOption(value);
                    }}
                  >
                    {Object.keys(approversOptions).map((option) => {
                      return (
                        <FormControlLabel
                          key={approversOptions[option].value}
                          value={approversOptions[option].value}
                          control={<Radio />}
                          label={`${t(`${tRP}.${approversOptions[option].translationKey}`)}`}
                        />
                      );
                    })}
                  </RadioGroup>
                </FormControl>
              </RadioGroupContainer>
            </Container>
          </Content>

          <DialogActions
            handleCancel={handleClose}
            useGoback
          >
            <Button
              onClick={handleExport}
              variant="contained"
            >
              {`${t("buttons.confirm")}`}
            </Button>
          </DialogActions>
        </LoadingOverlay>
      </Dialog>
    </>
  );
};

export default ExportToExcelApproversDialog;
